<!-- 2. 계약서 작성 -->
<template>
  <v-row no-gutters>

    <!--내용-->
    <v-col cols="12" class="write_conYscroll">
          <v-row no-gutters class="Wstep2_file_inP_box justify-center">
            <v-col cols="12" sm="8" md="8" lg="8">
						  <v-file-input
								class="inputH48_01 W100W Hauto mobile_W100"
                label="계약서 파일"
                placeholder="여기를 눌러 계약서를 업로드해주세요"
                :rules="rules.fileUploadRules"
                :accept="upload.uploadCtrPaperAccept"
                outlined
                chips
                dense
								:disabled="(step3Cntrl.disableUploadBtn === 'Y') ? true : false"
                @change="fileCheck"
							 ref="ctrPaperUpload" v-model="files"></v-file-input>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" class="ta_right"  v-if="this.fileuploadAfter === false ">
              <!--업로드 전 버튼 텍스트: 업로드 / 업로드 후 버튼 텍스트: 다운로드-->
              <v-btn class="btn17_C01" @click="ctrPaperFileUpload(0)">업로드</v-btn>
              <!--업로드 전 버튼 텍스트: 초기화 / 업로드 후 버튼 텍스트: 재업로드-->
            </v-col>
						<v-col cols="12" sm="4" md="4" lg="4" class="ta_right"  v-else>
							<v-btn class="btn17_C01" @click="downloadConvPDF()">다운로드</v-btn>
              <!--업로드 전 버튼 텍스트: 초기화 / 업로드 후 버튼 텍스트: 재업로드-->
              <v-btn outlined class="btn17_00" v-if="this.pevMove === false" @click="ctrPaperFileUpload(0)">재업로드</v-btn>
						</v-col>
          </v-row>
          <v-row no-gutters class="Wstep2_file_outP_box">
            <ul>
              <li>- <font class="fc_C03">10MB 이하</font>의 파일만 선택 가능합니다.</li>
              <li>- 업로드한 계약서 파일은 PDF 파일로 변환됩니다.</li>
              <li>- 계약서 파일을 선택한 후 <font class="fc_C01">[업로드] 버튼</font>을 클릭해야 계약서 업로드가 완료됩니다.</li>
            </ul>
          </v-row>
          <!--/드래그&드랍-->
          <v-row no-gutters class="row_mb-40" v-if="this.fileuploadAfter === true ">
            <v-col cols="12" class="mt-5">
              <v-file-input class="inputH48_01 W100W Hauto"
                label="첨부파일"
                placeholder=" "
                :rules="rules.attachFileUploadRules"
                :accept="upload.uploadCtrPapaerAttachAccept"
                outlined
                chips
                multiple
                dense
								ref="ctrPaperAttachUpload" v-model="attachFiles"
                @change="chkPaperAttachFileUpload"
								:disabled="(step3Cntrl.disableUploadBtn === 'Y') ? true : false"
              >
							<template v-slot:selection="{ text }">
								<v-chip
									small
									label
									color="primary"
								>
									{{ text }}
								</v-chip>
							</template>
							</v-file-input>
            </v-col>
          </v-row>
          <v-row no-gutters class="row_mb-40" :model="ctrFrmStep3"  v-if="this.fileuploadAfter === true ">
            <div class="dot_tt">부가정보 등록</div>
            <div class="txtst_info_gray">계약과 관련된 부가정보를 입력해주세요.</div>
            <v-col cols="12" class="mt-5">
              <v-row no-gutters class="coNlistCon_sideInfo" v-for="(item, index) in ctrFrmStep3.metaDataTmpList" :key="index">
                <!--(아래 [부가정보 추가] 버튼 누를시 마다 반복적으로 추가)-->
                <v-col cols="12" class="coNlist_receiverCpn">
                  <v-card class="carD_sideInfo">
										<v-form ref="metaForm" v-model="valid" lazy-validation>
                    <!--  기업:li 4개 버튼 2개 / 간편: li 3개 버튼 1개 -->
                    <ul class="pattern_ulTxtBox">
											<li v-if="pevMove === true">
                        <!--conBstar 텍스트 필드 미입력시 에러메세지 노출 및 리스트 추가 안됨-->
                        <v-text-field class="inputH48_03 conBstar"
                          label="제목"
													placeholder="제목을 입력해주세요."
													:rules="rules.subjectRules"
													readonly
                          v-model="item.key"
													:prop="'ctrFrmStep3.metaDataTmpList.' + index + '.key'"
                        >
                        </v-text-field>
                      </li>
                      <li v-else-if="!item.isRcvData">
                        <!--conBstar 텍스트 필드 미입력시 에러메세지 노출 및 리스트 추가 안됨-->
                        <v-text-field class="inputH48_03 conBstar"
                          label="제목"
													placeholder="제목을 입력해주세요."
													:rules="rules.subjectRules"
													required
                          v-model="item.key"
													:prop="'ctrFrmStep3.metaDataTmpList.' + index + '.key'"
                        >
                        </v-text-field>
                      </li>
											<li v-else>
                        <!--conBstar 텍스트 필드 미입력시 에러메세지 노출 및 리스트 추가 안됨-->
                        <v-text-field class="inputH48_03 conBstar"
													:value="item.key"
                          label="제목"
													readonly
													placeholder="계약 수신자가 설정한 부가정보는 수정할 수 없습니다."
                          v-model="item.key"
													:prop="'ctrFrmStep3.metaDataTmpList.' + index + '.key'"
                        >
                        </v-text-field>
                      </li>
                      <li v-if="pevMove === false">
                        <v-text-field class="inputH48_03"
                          label="내용"
													:value="item.val"
                          v-model="item.val"
													:prop="'ctrFrmStep3.metaDataTmpList.' + index + '.val'"
                        >
                        </v-text-field>
                      </li>
											<li v-else>
                        <v-text-field class="inputH48_03"
                          label="내용"
													:value="item.val"
                          v-model="item.val"
													readonly
													:prop="'ctrFrmStep3.metaDataTmpList.' + index + '.val'"
                        >
                        </v-text-field>
                      </li>
                    </ul>
                    <div class="btnCon_carD_receiv">
                      <v-btn icon class="btnO_C04 delete"  v-if="pevMove === false && item.isRcvData === false"><span class="icon"  @click="removeMetaData(index)">삭제</span></v-btn>
                    </div>
										</v-form>
                  </v-card>
                </v-col>
                <!--/(아래 [부가정보 추가] 버튼 누를시 마다 반복적으로 추가)-->
              </v-row>
              <v-btn text class="btn17_C01" v-if="this.ctrFrmStep3.metaDataTmpList.length < this.ctrFrmStep3.metaDataAddLimitCnt" @click="addMetaData()"><span class="icon"></span>부가정보 추가</v-btn>
            </v-col>
          </v-row>
           <!--/드래그&드랍 후-->
    </v-col>

		<v-footer bottom class="steperF_btnCon justify-center">
        <v-btn outlined class="btn19_00" @click="prevStep ()" ><span class="iconarr stP"></span>이전</v-btn>
        <v-btn class="btn19_C01" @click="validateConvPDFPath(keyNames.ctrReqMode.ctrReq)" :disabled="(step3Cntrl.disableCtrReqBtn === 'Y') ? true : false">다음<span class="iconarr stN"></span></v-btn>
    </v-footer>
		<s-confirm ref="confirm"></s-confirm>
  	<s-loading ref="loading"></s-loading>
</v-row>
</template>
<script>
import {
	getSettingContract,
	convFrmDataToReqJsonParam,
	ctrPaperFileUpload,
	validateConvPDFPath,
	chkInclFirstLetterNumTxt,
	chkInclFirstLetterWhiteSpaceTxt,
	chkInclSpecialCharTxt,
	defaultConstValue,
	reqCtrPaperConvToPDF,
	reqMakeConvPDFThumb,
	chkConvPdfStatus,
	ctrPaperAttachUpload
} from '@/api/contract/addNew'

const KEY_NAMES_OBJ = defaultConstValue()

export default {
  name: 'uploadContract',
  props: {
    parentData: {}
  },
  components: {
	},
	data () {
    return {
			valid: true,
			keyNames: KEY_NAMES_OBJ, // 전역적으로 임의로 사용되는 key값에 대한 상수모음(immutable)
      urls: {
        addrIFSysUrl: process.env.VUE_APP_ADDR_IF_SYS_URL,
        ctrFrmGetThnUrl: process.env.VUE_APP_CTR_FRM_GET_THN_URL,
        ctrPaperGetThnUrl: process.env.VUE_APP_CTR_PAPER_GET_THN_URL,
        downloadPDFUrl: process.env.VUE_APP_DOWNLOAD_PDF_URL,
				payreqCrossplatform: process.env.VUE_APP_URL_PAYREQ_CROSSPLATFORM
			},
			rules: {
				fileUploadRules: [
					v => !!v || v.size < 10000000 || '10MB 이하의 파일만 선택 가능합니다.',
				],
				attachFileUploadRules: [
					v => !!v || v.size < 30000000 || '30MB 이하의 파일만 선택 가능합니다.',
				],
				subjectRules: [
					v => !!v || '제목을 입력해주세요.',
					v => /^[^0-9'][A-Z0-9a-z0-9\u3131-\u318E\uAC00-\uD7A3]{0,1996}$/.test(v) || '형식을 확인해주세요.(특수문자, 공백, 첫문자 숫자 불가)'
				],
			},
			step: 2,
			reqParamJson: {},
			fileuploadAfter: false,
			pevMove: false,
			upload: {
        ctrPaperFileUploadEv: {}, // 계약서 수동 업로드시 http-request event를 저장
        ctrPaperAttachFileUploadEv: {}, // 파일첨부 수동 업로드시 http-request event를 저장
        fileCtrPaperList: [],
        fileCtrPaperReUpList: [],
        fileCtrPaperAttachList: [],
        ctrTmpAttachList: [],
        uploadCtrPaperAccept: '.jpg, .jpeg, .gif, .bmp, .png, .doc, .docx, .pdf, .xls, .xlsx, .ppt, .pptx',
        uploadCtrPapaerAttachAccept: '.jpg, .jpeg, .gif, .bmp, .png, .doc, .docx, .pdf, .zip, .7z, .alz, .xls .xlsx, .ppt, .pptx',
        uploadCtrPaperLimitVol: 10, // MB 단위, 계약서 업로드 용량 limit
        uploadCtrPaperExceed: 1, // 계약서 업로드 허용갯수
        uploadCtrPaperAttachLimitVol: 30, // MB 단위, 첨부파일 업로드 용량 limit
        uploadCtrPaperAttachExceed: 5, // 첨부파일 업로드 허용갯수
        ctrPaperFileInfo: {}, // 계약서 파일 정보 (업로드 후)
        ctrPaperAttachFileInfo: {} // 계약서 첨부 파일 정보 (업로드 후)
			},
			resStatCode: {
        ok: 20000,
        fail: 40002
      },
			tmpUploadPrc: {
        ctrPaperUpInfo: {},
        ctrPaperAttachInfo: []
			},
			files: [],
			attachFiles: [],
			ctrFrmStep3: {
        // addinput1: ''
        metaDataAddLimitCnt: 10, // 메타데이터 추가(부가데이터) 제한 건수
        metaDataTmpList: []
			},
			step3Cntrl: {
        ctrTmpAttachListLoading: false,
        disableCtrPaperReupBtn: 'N',
        disableCtrReqBtn: 'Y',
        disableCtrSaveBtn: 'N',
        disableCtrReqFinalBtn: 'N',
        waterMarkAttachStat: false,
				disableCtrFinalReqBtn: 'N',
				disableUploadBtn: 'N'
			},
			pdfConvPrc: {
        convPdfReqId: '',
        isPDFConvFail: false,
        isFinishConvPDF: false,
        isConvPDFPathOK: false,
        isConvPDFPathOKToMakeThumb: false,
        recursiveCallChkPDFPathLimit: 0,
        recursiveCallThresholdCnt: 10, // PDF 썸네일 만들기 위해 callback 지연에 대한 검사 제한 횟수
        isExecWmPrc: false, // 워터마크 프로세스 실행 여부
        convertedPDFThumbNail: '',
        // defaultThumbNailView: 'https://image.flaticon.com/icons/png/128/136/136522.png'
        defaultThumbNailView: 'https://png.icons8.com/color/240/000000/pdf-2.png',
        viewPdfThumbUrl: ''
			},
			preview: 'N'
		}
	},
	mounted () {
		this.reqParamJson = this.parentData
		var tmpUploadPrc = 'tmpUploadPrc'
		var ctrPaperUpInfo = 'ctrPaperUpInfo'
		var metaDataTmpList = 'metaDataTmpList'
		var ctrPaperAttachInfo = 'ctrPaperAttachInfo'
		if (this.reqParamJson[tmpUploadPrc] !== undefined ) {
			this.tmpUploadPrc.ctrPaperUpInfo = this.reqParamJson[tmpUploadPrc][ctrPaperUpInfo]
			this.ctrFrmStep3.metaDataTmpList = this.reqParamJson[metaDataTmpList]
			this.tmpUploadPrc.ctrPaperAttachInfo = this.reqParamJson[tmpUploadPrc][ctrPaperAttachInfo]
			this.requestDisplay()

		}else {
		}
  },
  created () {
  },
  filters: {
	},
	methods: {
    // MARK DELEGATE METHOD
    prevStep () {
      if(this.preview === 'Y') {
        this.$emit('prevStep', this.step, this.reqParamJson)
      }else {
        this.$refs.confirm.open('confirm', '날짜 선택', '작성중인 내용은 저장되지 않습니다. 이전단계로 이동하시겠습니까?').then(() => {
          this.$emit('prevStep', this.step, this.reqParamJson)
        })
      }

    },
    nextStep () {
      // this.$emit('nextStep', this.step, this.tmpUploadPrc)
      this.step++
		},
		ctrPaperFileUpload (cnt) {
      this.pdfConvPrc.recursiveCallChkPDFPathLimit = cnt;

      this.step3Cntrl.disableCtrReqBtn = 'Y'
      // 계약서를 업로드 한다(수동)
      if (this.files.name !== '' && this.files.name !== undefined) {
        // 다음 step 넘어가기 전까지 풀스크린 mask
				this.$refs.loading.start('계약서 변환중입니다.')

				let fileData =  {}
				fileData = this.files
				const data = new FormData()
				data.append(this.keyNames.ctrPaperUpInfoKeys.file, fileData) // 업로드 파일 설정
				data.append(this.keyNames.ctrPaperUpInfoKeys.ctrPaperData, JSON.stringify(this.reqParamJson)) // 일반 form 파라미터 설정
				ctrPaperFileUpload(data).then(response => {
					if (response.rcode === this.resStatCode.ok) {
						// 업로드 상태를 셋팅한다
						this.tmpUploadPrc.ctrPaperUpInfo = response.rdata.ctrPaperTmpUpResult


						this.fileuploadAfter = true

						setTimeout(() => {
                // form builder 초기화
                this.$nextTick(() => {
                  this.ctrPaperConvToPDF() // 비동기 pdf 변환 수행
                  // this.initFormBuilder() // 기획변경, 20180607 formbuilder 사용안함
                })
              }, 1000)
					} else {
						this.$refs.loading.end() // 풀스크린 로딩 해제
						this.$refs.confirm.open('alert', '계약서 업로드', '계약서 업로드 진행 중 오류가 발생했습니다.')
						this.tmpUploadPrc.ctrPaperUpInfo = {}
						this.upload.fileCtrPaperList = []
					}
				}).catch((e) => {
					this.$refs.loading.end() // 풀스크린 로딩 해제
					this.$refs.confirm.open('alert', '계약서 업로드', '계약서 업로드 진행 중 오류가 발생했습니다.')
					this.tmpUploadPrc.ctrPaperUpInfo = {}
					this.upload.fileCtrPaperList = []
				})
        this.tmpUploadPrc.ctrPaperUpInfo = {}
        this.upload.fileCtrPaperList = []

        // 업로드와 관계없이 다음 step으로 넘어가기 전 수신자 기준 Meta 데이터를 가져온다
				// (step3으로 넘어갔을때 PDF 컨버팅, 썸네일 생성에 지장이 없도록 미리 가져오게 함)

				this.getSettingContract()
      } else {
				// this.$message.info('계약서 파일을 선택 후 업로드 하시기 바랍니다.')
				this.$refs.confirm.open('alert', '계약서 업로드', '계약서 파일을 선택 후 업로드 하시기 바랍니다.')
      }
      // this.$refs.ctrPaperUpload.submit()
		},
		ctrPaperConvToPDF () {
      // 에디트 내용 or 업로드 된 계약서 파일을 PDF로 변환한다
      // 1. PDF서버에 변환 요청
      // 2. PDF 변환상태 주기적 호출, stateful이 null(완료) 되는지 확인

      // 업로드한 계약서 데이터를 셋팅한다 (이 경우엔 업로드한 계약서 데이터만 넘어감)
      this.reqParamJson[this.keyNames.reqParamKeys.tmpUploadData] = this.tmpUploadPrc
      reqCtrPaperConvToPDF(convFrmDataToReqJsonParam(this.reqParamJson)).then(response => {
        this.pdfConvPrc.isPDFConvFail = false
				// this.$refs.loading.start('계약서 파일을 PDF 파일로 변환 중입니다.')
        if (response.rcode === this.resStatCode.ok) {
          // 변환요청이 성공이면 변환 상태를 Polling한다
          // PDF변환 요청이 있으면 변환 서버에서 상태를 polling함
          var convPDFFileName = response.rdata.uploadPDFFileName
          this.pdfConvPrc.convPdfReqId = response.rdata.requestPDFConvId
          this.reqParamJson[this.keyNames.reqParamKeys.pdfConvReqPrcInfo] = {
            requestPDFConvId: this.pdfConvPrc.convPdfReqId
          }
          // 20180531 - 변환된 PDF파일 명 셋팅 시점 변경 - polling 상태일때 파일명을 셋팅하도록 변경
          this.tmpUploadPrc.ctrPaperUpInfo[this.keyNames.ctrPaperUpInfoKeys.uploadPDFFileName] =
						convPDFFileName.substring(0, convPDFFileName.lastIndexOf('.')) + '.pdf'

          chkConvPdfStatus(convFrmDataToReqJsonParam(this.reqParamJson)).then(response => {
            if (response.rcode === this.resStatCode.ok && response.rdata.statefulMapStat === 'Y') {
              // this.progressCntrl.convertPrcLoadingTxt = '변환된 PDF 파일의 다운로드 링크를 생성 중입니다.'
              // PDF 변환 후 시간차가 있어서 일단 timeout추가
              setTimeout(() => {
                // this.$nextTick(() => {
                // this.$message.info('PDF 변환이 완료되었습니다.')
                this.pdfConvPrc.isPDFConvFail = false // 변환 실패여부를 변경
                this.pdfConvPrc.isFinishConvPDF = true // 저장, 계약요청시에 PDF변환 완료 여부로 저장 가능여부 검사
                this.pdfConvPrc.convPdfReqId = ''
                this.reqParamJson[this.keyNames.reqParamKeys.pdfConvReqPrcInfo] = null
                delete this.reqParamJson[this.keyNames.reqParamKeys.pdfConvReqPrcInfo]
                // 변환된 PDF 파일이 정상적으로 위치하는지 검사한다
                // (PDF 서버 callback 지연등으로 파일이 늦게 생성되는 경우가 있으므로 검사)
                this.chkPDFConvCompToMakeThumb()
              }, 2500)
            } else {
							this.$refs.confirm.open('alert', '계약서 업로드', '계약서를 인식할 수 없습니다.<br>문서 내 비밀번호가 설정되어 있거나. 오피스 프로그램에서 정상적으로 열리는지 확인하세요.')
              this.prcFailConvPDF()
            }
          }).catch(() => {
						this.$refs.confirm.open('alert', '계약서 업로드', '계약서를 인식할 수 없습니다.<br>문서 내 비밀번호가 설정되어 있거나. 오피스 프로그램에서 정상적으로 열리는지 확인하세요.')
						this.$refs.loading.end()
            this.prcFailConvPDF()
          })
        } else {
					this.$refs.confirm.open('alert', '계약서 업로드', '계약서를 인식할 수 없습니다.<br>문서 내 비밀번호가 설정되어 있거나. 오피스 프로그램에서 정상적으로 열리는지 확인하세요.')
					this.$refs.loading.end()
          this.prcFailConvPDF()
        }
      }).catch(() => {
				this.$refs.confirm.open('alert', '계약서 업로드', '계약서를 인식할 수 없습니다.<br>문서 내 비밀번호가 설정되어 있거나. 오피스 프로그램에서 정상적으로 열리는지 확인하세요.')
				this.$refs.loading.end()
        this.prcFailConvPDF()
      })
		},
		chkPDFConvCompToMakeThumb () {
      // 변환된 PDF 파일이 정상적으로 위치하는지 검사, PDF 첫페이지 썸네일 생성
      // (PDF 서버 callback 지연등으로 파일이 늦게 생성되는 경우가 있으므로 검사)
      // this.progressCntrl.convertPrcLoading = true
      // this.progressCntrl.convertPrcLoadingTxt = '변환된 PDF 파일의 미리보기를 생성 중입니다.'
      validateConvPDFPath(convFrmDataToReqJsonParam(this.reqParamJson)).then(response => {
        if (response.rcode === this.resStatCode.ok) {
          this.isConvPDFPathOKToMakeThumb = response.rdata.isConvPDFPathOK
          if (this.isConvPDFPathOKToMakeThumb) {
            // 변환된 PDF의 썸네일을 생성한다
            reqMakeConvPDFThumb(convFrmDataToReqJsonParam(this.reqParamJson)).then(response => {
              if (
                response.rcode === this.resStatCode.ok &&
                response.rdata.convertedPDFThumbNail !== undefined &&
                response.rdata.convertedPDFThumbNail !== ''
              ) {
                // PDF 변환시 생성된 첫페이지 썸네일의 파일명을 셋팅해준다
                this.pdfConvPrc.convertedPDFThumbNail = response.rdata.convertedPDFThumbNail
              } else {
                this.pdfConvPrc.convertedPDFThumbNail = ''
              }
              this.step3Cntrl.disableCtrReqBtn = 'N' // 계약요청 버튼 활성화
              this.$refs.loading.end()
            }).catch(() => {
              this.pdfConvPrc.convertedPDFThumbNail = ''
              this.prcFailConvPDF()
            })
          } else {
            this.pdfConvPrc.convertedPDFThumbNail = ''
            // callback이 지연되어 파일검사가 제대로 안될수 있어 재호출
            // setTimeout(() => {
            this.pdfConvPrc.recursiveCallChkPDFPathLimit++
            console.log("콜백 횟수", this.pdfConvPrc.recursiveCallChkPDFPathLimit);
            console.log("한계점", this.pdfConvPrc.recursiveCallThresholdCnt);

            if (this.pdfConvPrc.recursiveCallChkPDFPathLimit >= this.pdfConvPrc.recursiveCallThresholdCnt) {
              this.pdfConvPrc.convertedPDFThumbNail = ''
              // 썸네일 생성 검사 모두 실패하더라도 관련 버튼들 재처리 해줌
              this.prcFailConvPDF()
              return false
            } else {
              this.chkPDFConvCompToMakeThumb()
            }
            // }, 1600)
          }
        } else {
          this.$refs.confirm.open('alert', '계약서 업로드', '계약서를 인식할 수 없습니다.<br>문서 내 비밀번호가 설정되어 있거나. 오피스 프로그램에서 정상적으로 열리는지 확인하세요.')
          this.pdfConvPrc.convertedPDFThumbNail = ''
          // this.step3Cntrl.disableCtrPaperReupBtn = 'N' // 다시 업로드 버튼 활성화
          this.step3Cntrl.disableCtrReqBtn = 'N' // 계약요청 버튼 활성화
          // this.step3Cntrl.disableCtrSaveBtn = 'N' // 계약저장 버튼 활성화
        }
      }).catch(() => {
				this.$refs.confirm.open('alert', '계약서 업로드', '계약서를 인식할 수 없습니다.<br>문서 내 비밀번호가 설정되어 있거나. 오피스 프로그램에서 정상적으로 열리는지 확인하세요.')
      })
		},
		prcFailConvPDF () {
      this.$refs.loading.end()
      this.$refs.confirm.open('alert', '계약서 업로드', '계약서를 인식할 수 없습니다.<br>문서 내 비밀번호가 설정되어 있거나. 오피스 프로그램에서 정상적으로 열리는지 확인하세요.')
      // PDF 변환 처리 실패 처리 공통
      this.reqParamJson[this.keyNames.reqParamKeys.tmpUploadData] = null
      delete this.reqParamJson[this.keyNames.reqParamKeys.tmpUploadData]
      this.reqParamJson[this.keyNames.reqParamKeys.pdfConvReqPrcInfo] = null
      delete this.reqParamJson[this.keyNames.reqParamKeys.pdfConvReqPrcInfo]
      this.pdfConvPrc.convPdfReqId = ''
      this.pdfConvPrc.isPDFConvFail = true
      this.pdfConvPrc.isFinishConvPDF = false
      this.pdfConvPrc.viewPdfThumbUrl = ''
      this.step3Cntrl.disableCtrReqBtn = 'Y' // 계약요청 버튼 비활성화
    },
		// 계약서 업로드 관련 Handler 시작
    getSettingContract () {
      // Admin에 셋팅된 meta data를 가져온다
      getSettingContract(convFrmDataToReqJsonParam(this.reqParamJson)).then(response => {
        if (response.rcode === this.resStatCode.ok) {
          var settingData = (response.rdata.settingData === undefined || response.rdata.settingData == null) ? null : response.rdata.settingData
          var admMetaList = null

          if (
            settingData !== undefined &&
            settingData != null &&
            Object.keys(settingData).length > 0 &&
            settingData.metaString !== undefined &&
            settingData.metaString !== ''
          ) {
            admMetaList = JSON.parse(settingData.metaString)
            // active 인것만 셋팅, JSON데이터 저장에 문제될만한 문자열은 replace
            this.ctrFrmStep3.metaDataTmpList = []
            for (let i = 0; i < admMetaList.length; i++) {
              if(admMetaList[i].active === '1') {
                let admMetaObj = {}
                admMetaObj = admMetaList[i]
                for (var key in admMetaObj) {
                  var tmpMetaObj = { key: '', val: '', isRcvData: true } // 수신자가 설정한 데이터 여부
                  var admMetaObjVal = admMetaObj[key]
                  var isActive = false
                  if (key === 'key') {
                    var activeValue = 'active'
                    isActive = admMetaObj[activeValue]
                    if (isActive) {
                      tmpMetaObj.key = admMetaObjVal.replace(/[`':"]/gi, '')
                      tmpMetaObj.val = ''
                    } else {
                      continue
                    }
                  } else {
                    continue
                  }
                  this.ctrFrmStep3.metaDataTmpList.push(tmpMetaObj)
                }
              }
            }
          } else {
            this.ctrFrmStep3.metaDataTmpList = []
          }
        }
      })
		},
		downloadConvPDF () {
      // 변환되어 임시로 로컬에 저장된 PDF를 다운로드 한다 (일반 다운로드)
      this.$nextTick(() => {
        window.open(
          this.urls.downloadPDFUrl +
          '/' +
          this.tmpUploadPrc.ctrPaperUpInfo[this.keyNames.ctrPaperUpInfoKeys.oriFileName], '_blank'
        )
      })
		},
		addMetaData() {
			// 메타데이터 입력 필드를 추가한다
				this.ctrFrmStep3.metaDataTmpList.push({ key: '', val: '', isRcvData: false }) // isRcvData - 수신자 설정 메타데이터 여부

    },
		removeMetaData (index) {
      // 메타데이터 입력 필드를 삭제한다
      this.ctrFrmStep3.metaDataTmpList.splice(index, 1)
      if (this.ctrFrmStep3.metaDataTmpList <= 0) {
        this.step3Cntrl.disableCtrReqBtn = 'N' // 계약요청 버튼 활성화
        this.step3Cntrl.disableCtrSaveBtn = 'N' // 계약저장 버튼 활성화
      }
		},
		ctrPaperAttachFileUpload () {
      // 수동 업로드 실행(첨부파일)
      if (this.attachFiles.length > 0) {

        if (this.attachFiles.length > this.upload.uploadCtrPaperAttachExceed) {
					this.$refs.confirm.open('alert', '', '총 ' + this.upload.uploadCtrPaperAttachExceed + '개의 파일까지 업로드 하실 수 있습니다.')
          // 첨부파일 임시 업로드 리스트, 파일정보 리스트 외에 업로드시 사용되는 리스트와 요소는 초기화
          this.upload.fileCtrPaperAttachList = []
        } else {


          for (var i = 0; i < this.attachFiles.length; i++) {
						var fileData = this.attachFiles[i]

            // 계약서의 첨부파일을 업로드 한다
            const data = new FormData()
            data.append(this.keyNames.ctrPaperAttachInfoKeys.file, fileData)
            data.append(this.keyNames.ctrPaperAttachInfoKeys.ctrPaperAttachData, JSON.stringify(this.reqParamJson)) // 일반 form 파라미터 설정

            ctrPaperAttachUpload(data).then(response => {
              if (response.rcode === this.resStatCode.ok) {
								// 업로드 결과를 셋팅한다
                this.tmpUploadPrc.ctrPaperAttachInfo.push(response.rdata.ctrPaperTmpAttachUpResult)
                // 임시 업로드 된 결과를 리스트로 보기 위해 셋팅 한다
								return true
              } else {
								return false
              }
            }).catch(() => {
							return false
            })
          }
					return true
        }
      } else {
				return true
      }
    },
    chkPaperAttachFileUpload () {
        if (this.attachFiles.length > this.upload.uploadCtrPaperAttachExceed) {
					this.$refs.confirm.open('alert', '', '총 ' + this.upload.uploadCtrPaperAttachExceed + '개의 파일까지 업로드 하실 수 있습니다.')
          // 첨부파일 임시 업로드 리스트, 파일정보 리스트 외에 업로드시 사용되는 리스트와 요소는 초기화
          this.upload.fileCtrPaperAttachList = []
          this.attachFiles = []
        }
    },
		validateConvPDFPath (reqKindVal) {
			if(this.preview === 'N') {
				var attachSucc = this.ctrPaperAttachFileUpload()

				if(attachSucc) {
					// 요청 종류 (reqKindVal) (최종 데이터 validation을 위해 사용함)
					// CTR_SAVE : 저장
					// CTR_REQ : 계약요청
					this.reqKind = reqKindVal

					// 변환된 PDF 파일이 정상적으로 위치하는지 검사한다
					// (PDF 서버 callback 지연등으로 파일이 늦게 생성되는 경우가 있으므로 검사)
					validateConvPDFPath(convFrmDataToReqJsonParam(this.reqParamJson)).then(response => {
						if (response.rcode === this.resStatCode.ok) {
							if (response.rdata.isConvPDFPathOK) {
								this.pdfConvPrc.isConvPDFPathOK = true
								if (reqKindVal === this.keyNames.ctrReqMode.ctrSave) { // 저장일때
									this.ctrSave()
								} else if (reqKindVal === this.keyNames.ctrReqMode.ctrReq) { // 계약요청일때
									this.ctrReq()
								}
							} else {
								this.pdfConvPrc.isConvPDFPathOK = false
								this.$refs.confirm.open('alert', '계약서 업로드', '계약서를 인식할 수 없습니다.<br>문서 내 비밀번호가 설정되어 있거나. 오피스 프로그램에서 정상적으로 열리는지 확인하세요.')
							}
						} else {
							this.pdfConvPrc.isConvPDFPathOK = false
							this.$refs.confirm.open('alert', '계약서 업로드', '계약서를 인식할 수 없습니다.<br>문서 내 비밀번호가 설정되어 있거나. 오피스 프로그램에서 정상적으로 열리는지 확인하세요.')
						}
					}).catch(() => {
						this.pdfConvPrc.isConvPDFPathOK = false
						this.$refs.confirm.open('alert', '계약서 업로드', '계약서를 인식할 수 없습니다.<br>문서 내 비밀번호가 설정되어 있거나. 오피스 프로그램에서 정상적으로 열리는지 확인하세요.')
					})
				}else {
					this.$refs.confirm.open('alert', '첨부파일등록', '첨부파일 등록에 실패하였습니다.')
				}
			}else {
				this.$emit('nextStep', this.step, this.reqParamJson)
			}
		},
		ctrReq () {
      // 계약요청 outer layer popup을 오픈
      this.popCtrReqOuterLayer()
    },
    ctrSave () {
		},
		popCtrReqOuterLayer () {
      // 동적 추가 메타데이터 검증
      var isValidMetaDatas = this.validateMetaDatas()
      // 계약요청 팝업 오픈전 최종 계약요청 버튼은 우선 disable 시킨다
      // 워터마크 처리가 완료되면 활성화 시킴
      // 20180607 워터마크 처리는 필수는 아니라함, 주석처리
      // this.step3VisibleCntrl.disableCtrReqFinalBtn = 'Y'
      if (isValidMetaDatas) {
				// 블록체인 암호 초기화
				var tmpUploadPrc = 'tmpUploadPrc'
				var metaData = 'metaData'
				var metaDataTmpList = 'metaDataTmpList'
        this.reqParamJson[tmpUploadPrc] = this.tmpUploadPrc
        this.reqParamJson[metaData] = this.convertMetaListToMap()
				this.reqParamJson[metaDataTmpList] = this.ctrFrmStep3.metaDataTmpList

        this.$emit('nextStep', this.step, this.reqParamJson)
      } else {
        if (!isValidMetaDatas ) {
					this.$refs.confirm.open('alert', '부가정보', '추가하신 부가정보의 형식을 다시 확인해 주세요.')
          return false
        }
      }
		},
		validateMetaDatas () {
      // 계약요청이나 저장 전등에 메타데이터 리스트를 검사한다
      let isValidMetaDatas = false
      var metaListValidErrCnt = 0
      if (
        this.ctrFrmStep3.metaDataTmpList !== undefined &&
        this.ctrFrmStep3.metaDataTmpList != null &&
        this.ctrFrmStep3.metaDataTmpList.length > 0
      ) {
        // {key:value} 형태의 map으로 변환한 데이터로 검증
        var convertedMetaMap = this.convertMetaListToMap()[0]
        for (var key in convertedMetaMap) {
          if (key === undefined || key == null || key === '') {
            metaListValidErrCnt++
          } else {
            if (chkInclFirstLetterNumTxt(key)) { // key value validation
              // 키에 첫번째 문자 숫자 패턴이 있으면 error count 증가
              metaListValidErrCnt++
            }
            if (chkInclFirstLetterWhiteSpaceTxt(key)) {
              // 키에 첫번째 문자 공백이 있으면 error count 증가
              metaListValidErrCnt++
            }
            if (chkInclSpecialCharTxt(key)) {
              // 키 특수문자 검사
              metaListValidErrCnt++
            }
          }
        }
        if (metaListValidErrCnt === 0) {
          isValidMetaDatas = true
        } else {
          isValidMetaDatas = false
        }
      } else {
        isValidMetaDatas = true
      }
      return isValidMetaDatas
		},
		convertMetaListToMap () {
      // 메타 데이터 리스트를 Map 형태로 변경 가공한다
      // (뒷단에서는 arr형태를 받지만 실제로는 arr[0]번째 데이터만 처리한다)
      var retArr = []

      if (this.ctrFrmStep3.metaDataTmpList != null && this.ctrFrmStep3.metaDataTmpList.length > 0) {
        var convertedObj = this.ctrFrmStep3.metaDataTmpList.reduce((accumulator, target) => (
          {
            ...accumulator, [target.key]: target.val
          }
        ), {})
        // 값에 single quote나 colon 등의 문자는 back end에서 JSON 오류 발생할 수
        // 있으므로 replace함 20180622
        for (var convertedObjKey in convertedObj) {
          var metaObjVal = convertedObj[convertedObjKey]
          convertedObj[convertedObjKey] = metaObjVal.replace(/[`':"]/gi, '')
        }

        retArr.push(convertedObj)
      }
      return retArr
		},
		requestDisplay() {
			this.fileuploadAfter = true
			this.pevMove = true
			var responseFile = { name: this.tmpUploadPrc.ctrPaperUpInfo.oriFileName }
			this.files = responseFile
			var tmpattachFileObj = []
      for (var i = 0; i < this.tmpUploadPrc.ctrPaperAttachInfo.length; i++) {
				var tmpObj = { name: '' }
				tmpObj.name = this.tmpUploadPrc.ctrPaperAttachInfo[i].oriFileName
				tmpattachFileObj.push(tmpObj)
			}
			var responseAttachFile = tmpattachFileObj
			this.attachFiles = responseAttachFile
			this.step3Cntrl.disableCtrReqBtn = 'N'
			this.step3Cntrl.disableUploadBtn = 'Y'
			this.preview = 'Y'
    },
    fileCheck() {
      var fileLen = this.files.name.length

      var lastDot = this.files.name.lastIndexOf('.')
      var fileExt = this.files.name.substring(lastDot, fileLen)
      if(this.upload.uploadCtrPaperAccept.indexOf(fileExt) === -1) {
        this.$refs.confirm.open('alert', '계약서 업로드', this.upload.uploadCtrPaperAccept+'파일만 업로드 가능합니다.')
        this.files = ''
      }
    }
	}
}
</script>
